import type { IExtractRouteParamMap, IRouteTranslation } from "../../types";
import { createBreadcrumbObject, createPaths, rebase } from "../../utils";

// Base route constant
const baseRoute = `/media-management`;

// * Route configuration object for mediaManagement-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const mediaManagementRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  view: `${baseRoute}/view/:mediaId`,
  edit: `${baseRoute}/edit/:mediaId`,
} as const;

// ! these are breadcrumbs translation not page title
const mediaManagementRouteTranslation: IRouteTranslation<
  typeof mediaManagementRoutesObj
> = {
  list: "mediaManagement",
  create: "addNews",
  edit: "editNews",
  view: "viewNews",
};

// * Extracts the route parameters for the mediaManagement route configuration.
export type IMediaManagementRouteParams = IExtractRouteParamMap<
  typeof mediaManagementRoutesObj
>;

// * Path functions for the mediaManagement routes.
export const mediaManagementPath = createPaths<
  typeof mediaManagementRoutesObj,
  IMediaManagementRouteParams
>(mediaManagementRoutesObj);

// * Breadcrumbs {translation and route} for the media routes
export const mediaBreadcrumbs = createBreadcrumbObject<
  typeof mediaManagementRoutesObj
>(mediaManagementRoutesObj, mediaManagementRouteTranslation);
rebase(mediaBreadcrumbs, "list");
